import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { Visibility } from '@documalis/_const/const';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { isInArrayKey } from '@core/_utils/tools.utils';
import { Message } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';
import { HeaderCustRight } from '../../header-custright';

@Component({
    selector: 'app-form-custrights',
    templateUrl: './form-custrights.component.html',
    styleUrls: ['./form-custrights.component.scss'],
    providers: [AutofocusDirective],
})
export class FormCustRightsComponent extends FormBase implements OnInit, OnDestroy {
    public resultForm: FormGroup;
    public validClick = false;
    public listVisibility = [];
    public visibility = 0;
    public isAdmin = false;

    @Input()
    public result: HeaderCustRight = null;

    @Input()
    public groupList = [];

    @Input()
    public userList = [];

    @Input()
    public screenList = [];

    @Input()
    public groupListUsed = [];

    @Input()
    public userListUsed = [];

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.resultForm = this.formBuilder.group({
            id: null,
            name: [{value: null, disabled: false}, [Validators.required, Validators.minLength(1), Validators.maxLength(45)]],
            label: [null, [Validators.required, Validators.minLength(1), Validators.maxLength(45)]],
            desc: null,
            visibility: [null, [Validators.required]],
            groupListUsed: null,
            userListUsed: null,
            typeitem: null,
        });
        this.initialization();
        this.loadVisibility('', Visibility);
        this.visibility = null;
    }

    ngOnInit() {
        if (this.result !== null) {
                this.result.notifyParent.subscribe(success => {
                this.resultForm.controls['name'].disable();                    
                this.resultForm.patchValue(this.result);
                this.visibility = this.result.visibility;
            })
        }
    }

    ngOnDestroy() {
        if (this.result !== null) {            
            this.result.notifyParent.unsubscribe()
        }
    }

    public onChangeVisibility($event) {
        this.visibility = $event.value;
    }

    public validate() {
        let wRequest: any;
        wRequest = new Object();
        if (this.resultForm.value.typeitem === null) {
            this.resultForm.value.typeitem = false;
        }
        wRequest = {
            entete: this.resultForm.getRawValue(),
        };
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            this.onValidate.emit(wRequest);
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.resultForm.getRawValue());
    }

    private loadVisibility(atype, avisibility) {
        // -1 : on ne prend pas le type system
        for (let i = 0; i < avisibility.length - 1; i++) {
            this.listVisibility.push({ label: avisibility[i].name, value: avisibility[i].id });
        }
    }

    private initialization() {
        this.keys = {
            name: {
                label: this.translate.instant('Screen'),
                pattern: '',
            },
            label: {
                label: this.translate.instant('Lab_Menu'),
                pattern: '',
            },
            visibility: {
                label: this.translate.instant('Access'),
                pattern: '',
            },
        };
    }
}
